"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelector = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const app_context_1 = require("@src/context/app-context");
const iso_639_1_1 = __importDefault(require("iso-639-1"));
const react_router_dom_1 = require("react-router-dom");
const localized_path_1 = require("@src/shared/localized-path");
const styled_components_1 = __importDefault(require("styled-components"));
const StyledSelect = (0, styled_components_1.default)(antd_1.Select) `
	& {
		width: 10rem;
	}
`;
const Flag = styled_components_1.default.img `
	width: 2rem;
	margin-right: 0.5rem;
	border: 1px solid lightgray;
	padding: 1px;
`;
const { Option } = antd_1.Select;
const LanguageSelector = props => {
    const appContext = (0, app_context_1.useAppContextValue)();
    const history = (0, react_router_dom_1.useHistory)();
    const onSelectHandler = value => {
        history.push((0, localized_path_1.getLocalizedPath)(history.location.pathname + history.location.search, value));
        appContext.setLanguage(value);
    };
    return ((0, jsx_runtime_1.jsxs)(StyledSelect, { value: appContext.language, onSelect: onSelectHandler, ...props, children: [(0, jsx_runtime_1.jsx)(Option, { value: "sk", children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Flag, { src: "/media/images/flag-slovakia.png", alt: iso_639_1_1.default.getNativeName('sk') }), iso_639_1_1.default.getNativeName('sk')] }) }), (0, jsx_runtime_1.jsx)(Option, { value: "en", children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Flag, { src: "/media/images/flag-united-kingdom.png", alt: iso_639_1_1.default.getNativeName('en') }), iso_639_1_1.default.getNativeName('en')] }) })] }));
};
exports.LanguageSelector = LanguageSelector;
